<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb" v-if="isMounted">
        <li class="breadcrumb-item" @click="$router.push('/investors')" style="cursor: pointer">Inversionistas</li>
        <li class="breadcrumb-item active" aria-current="page" v-if="!withSubPath">{{ fiscalName }}</li>
        <li class="breadcrumb-item" @click.stop="backToMain" style="cursor: pointer" v-if="withSubPath">
          {{ fiscalName }}
        </li>
        <li class="breadcrumb-item active" aria-current="page" v-if="withSubPath">{{ subPathName }}</li>
      </ol>
    </nav>


    <div class="container-fluid" v-if="isMounted">
      <vx-card card-background="dark">
        <h3 class="bold big-title m-0 text-white">{{ fiscalName }}, IID: <span>{{ investor.id }}</span>, UID:
          <span>{{ investor.user.id }}</span>
        </h3>
      </vx-card>
      <vx-card class="mt-5 mb-4">
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <p class="text-dark mb-1">
              Email: <span class="bold pill-dark">{{ email }}</span> <br>
              Teléfono: <span class="bold">
                <template v-if="phoneNumber">
                  <a :href="$sanitizeUrl(wpPhoneLink)" target="_blank">
                    {{ phoneNumber }}
                  </a>
                </template>
                <template v-else>--</template>
              </span><br>
              Estatus de usuario: <span class="bold">{{ accountVerifyText }}</span> <br>
              Estatus de inversionista: <span class="bold">{{ investorStatusText }}</span> <br>
              Fecha de último acceso: <span class="bold">{{ lastSession }}</span>
              <!-- Datos sobre la verificación de identidad del usuario -->
              <user-identity-verification :user-id="investor.user.id" />
              <stp-button :variant="'investor'" :id="investor.id" />
            </p>
          </div>
          <div class="vx-col w-full md:w-1/2">
            <p class="text-dark mb-1">
              Onboarding (etapa) : <span class="bold pill-secondary">{{ investor.onboarding_step }}</span> <br>
              Nivel de operación: <span class="bold pill-secondary">{{ investor.contract_level }}</span> <br>
              Nivel de ImpactaMás: <span class="bold">{{ currentLevel }}</span> <br>
              Saldo: <span class="bold pill-primary">{{ investor.final_balance | currency }}</span> <br>
            </p>
            <user-emails-sent-list :userEmail="email" />
          </div>
        </div>
      </vx-card>

      <router-view v-if="isMounted"></router-view>
    </div>
  </div>
</template>

<script>
import InvestorProfileRootPage from "@/views/admin/investor/InvestorProfileRootPage";
import userAccountStatusHelper from "@mixins/userAccountStatusHelper";
import dateHelper from "@mixins/dateHelper";
import UserIdentityVerification from '@components/profile_shared/UserIdentityVerification';
import UserEmailsSentList from "@components/profile_shared/UserEmailsSentList";
import { BankAccountStatus } from "@/models/BankAccountStatus";
import StpButton from "@components/stp/StpButton";

export default {
  name: "InvestorDetails",
  data: () => ({
    loaded: false,
    activeTab: 0,
    isMounted: false,
    investor: {
      id: null,
      user: {
        person_type: 1
      }
    },
    withSubPath: false,
    subPathName: null,
    subPathParent: null,
    lastLogin: null,
    currentLevel: null
  }),
  mixins: [userAccountStatusHelper, dateHelper],
  components: {
    InvestorProfileRootPage,
    UserIdentityVerification,
    UserEmailsSentList,
    StpButton
  },
  computed: {
    person() {
      return (this.investor.user.person_type === 0 || this.investor.user.person_type === 3) ? this.investor.user.business : this.investor.user.personal;
    },
    fiscalName() {
      if (this.investor.user.person_type === 1 || this.investor.user.person_type === 2) {
        return `${this.person.first_name} ${this.person.second_name} ${this.person.last_name_1} ${this.person.last_name_2}`
      } else {
        return this.person.name;
      }
    },
    email() {
      return this.investor.user.email;
    },
    alias() {
      return this.investor.user.alias || "No definido";
    },
    lastSession: function () {
      let ss = "";
      if (this.lastLogin != null && this.lastLogin != '') {
        ss += this.sessionFormat(this.lastLogin);
      } else {
        ss += "-";
      }
      return ss;
    },
    bankVerifyText() {
      if (this.person.bank_accounts.length > 0) {
        return BankAccountStatus.getAccountStatusName(
          this.person.bank_accounts[0].verified
        )
      }

      return 'Cuenta de banco no verificada';
    },
    accountVerifyText() {
      return this.userAccountStatusName(this.investor.user.active);
    },
    investorStatusText() {
      return this.investorAccountStatusName(this.investor.status);
    },
    phoneNumber() {
      let number = null;
      let phone = this.person.phone;
      if (phone) {
        return phone.phone;
      } else {
        return number;
      }
    },
    wpPhoneLink() {
      return "https://wa.me/" + this.phoneNumber;
    }
  },
  async mounted() {
    this.composeBreadcrumb();
    try {
      let investor_id = this.$route.params.id;
      window.document.title = `IID: ${investor_id}`;

      const { data } = await axios.get(`/api/investor/${investor_id}`, {
        params: {
          with: [
            'user.personal.bankAccounts',
            'user.personal.phone',
            'user.business.bankAccounts',
            'user.personal.creditProfile',
            'user.business.creditProfile',
            'user.business.address',
            'user.business.personal',
            'user.business.phone',
          ]
        }
      });
      this.investor = data;
      const res = await axios.get(`/api/investor/${investor_id}/lastLogin`);
      this.lastLogin = res.data;
      const res2 = await axios.get(`api/v2/investor/${investor_id}/getLevelData`);
      this.currentLevel = res2.data.level.level;
      this.isMounted = true;
    } catch (e) {
      console.error(e)
    } finally {
      this.loaded = true;
    }
  },
  watch: {
    '$route'() {
      this.composeBreadcrumb();
    },
  },
  methods: {
    composeBreadcrumb() {
      const route = this.$route;
      if (route.meta.breadcrumb) {
        this.withSubPath = true;
        this.subPathName = route.meta.breadcrumb.name;
        this.subPathParent = route.meta.breadcrumb.parent;
      } else {
        this.withSubPath = false;
      }
    },
    async backToMain() {
      await this.$router.push({ name: 'investorTabs', params: { tab: this.subPathParent } });
    },
  }
}
</script>

<style scoped>
.resume-card-info {
  margin-left: 24px;
}
</style>